export default __webpack_public_path__ + "static/media/404.a7ea7627.gif";